import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformDetectionService } from './platform-detection.service';

@NgModule({
  imports: [CommonModule],
  providers: [PlatformDetectionService],
})
export class SharedModule {}
